"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Experiencia() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  return <section id="experiencia" ref={sectionRef} className={`relative py-32 md:py-48 bg-muted-light-background overflow-hidden transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center justify-center">
          <div className={`order-first lg:order-none relative w-full overflow-hidden rounded-2xl shadow-strong transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/caribbean_sunset_dining_experience.png" alt="Caribbean sunset terrace dining" className="w-full h-[320px] md:h-[520px] object-cover block" loading="lazy" />
          </div>

          <div className={`space-y-8 transition-all duration-[var(--duration-medium)] delay-150 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="max-w-[620px]">
              <span className="text-accent font-medium tracking-widest uppercase text-sm mb-4 block">
                Frente al Caribe
              </span>
              <h2 className="text-5xl md:text-6xl lg:text-7xl text-foreground font-display leading-[1.1] mb-6">
                Una Experiencia <span className="text-primary-dark">Junto al Mar</span>
              </h2>
              <div className="w-20 h-1 bg-primary/30 mb-10" />

              <div className="space-y-6 text-foreground/90 text-lg md:text-xl leading-[1.75]">
                <p>
                  En Marea Mezcal, cada cena se transforma en una experiencia sensorial única. Ubicados frente a las aguas turquesas del Caribe, nuestro restaurante fusiona la autenticidad de los sabores mexicanos tradicionales con técnicas contemporáneas y una presentación artística.
                </p>

                <p>
                  Imagina disfrutar de platillos exquisitamente elaborados mientras la brisa marina acaricia tu rostro y el sol se despide en el horizonte. Nuestro ambiente tropical-lujoso crea el escenario perfecto para celebraciones especiales, cenas románticas o simplemente una velada inolvidable.
                </p>

                <p>
                  Cada ingrediente es seleccionado cuidadosamente de productores locales, garantizando frescura y autenticidad en cada bocado. Desde nuestros ceviches con toques innovadores hasta nuestros cortes premium marinados con especias ancestrales, cada plato cuenta una historia.
                </p>
              </div>

              <div className="pt-10">
                <Link to="/MareaMezcalExperiencePage">
                  <Button variant="default" size="lg" className="group bg-primary text-white border-primary hover:bg-primary-hover hover:border-primary-hover shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-10 py-7 text-lg font-semibold rounded-md">Explorar la Experiencia</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}